const stats = [
  { value: "24/7", label: "Support Available" },
];

export default function AboutSection() {
  return (
    <section
      id="about"
      className="w-full py-28 md:py-36 px-6 md:px-12 lg:px-20"
      style={{ background: "linear-gradient(165deg, #F5F5F7 0%, #FAFAFA 100%)" }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Label */}
        <span className="block text-xs uppercase tracking-widest text-gray-400 font-medium mb-8">
          Who We Are
        </span>

        {/* Main content */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24">
          {/* Text */}
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug mb-6">
              A dedicated team of iOS experts, building applications that matter.
            </h2>
            <p className="text-base md:text-lg text-gray-500 leading-relaxed max-w-xl">
              FORMO d.o.o. was founded with a singular mission: to create iOS applications that genuinely improve people&apos;s digital lives. Our team combines deep technical expertise with a passion for clean, intuitive design — delivering products that users trust and love.
            </p>
            <p className="mt-4 text-base md:text-lg text-gray-500 leading-relaxed max-w-xl">
              From enterprise-grade VPN security to smart device maintenance tools, every product we ship reflects our commitment to quality, performance, and user privacy.
            </p>
          </div>

          {/* Image */}
          <div className="flex-shrink-0 w-full lg:w-80 xl:w-96 h-64 lg:h-auto rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/8685e0aff74f89fba61b203490d03129.jpg"
              alt="FORMO d.o.o. team"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-1 gap-10">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col">
              <span className="text-5xl md:text-6xl font-bold text-gray-900 tracking-tight leading-none">
                {stat.value}
              </span>
              <span className="mt-3 text-sm text-gray-400 font-medium">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
